import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IBlogListResponse, IConfigurationResponse, IMidwifeProfileResponse, ISearchMidwifeBody, ISearchMidwifeResponse } from '../models/dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getRecentBlogs(limit: number, offset: number): Observable<IBlogListResponse>{
    const url = `${environment.serverUrl}blog/recentposts`;
    let body={
      offset: offset,
      limit: limit
    }
    return this.http.post<IBlogListResponse>(url, body);
  }

  searchMidwife(body: ISearchMidwifeBody): Observable<ISearchMidwifeResponse>{
    const url = `${environment.serverUrl}midwife/search`;
    return this.http.post<ISearchMidwifeResponse>(url, body);
  }

  getMiscConfiguration(): Observable<IConfigurationResponse>{
    const url = `${environment.serverUrl}misc/configuration`;
    return this.http.get<IConfigurationResponse>(url);
  }

  getMidwifeProfileDetail(midwifeId: number): Observable<IMidwifeProfileResponse>{
    let body={
      midwifeId: midwifeId,
    }
    const url = `${environment.serverUrl}midwife/profile`;
    return this.http.post<IMidwifeProfileResponse>(url, body);
  }
}
